.ImageNoPointerEvents {
  pointer-events: none;
  width: 100%;
  height: 100%;
}
